<template>
  <span class="emoji">
    <img
      v-if="value.startsWith('/')"
      class="emoji_icon"
      :src="`/img/emoji${value}`"
    />
    <span v-else class="emoji_icon">{{ value }}</span>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style></style>
